// Exact text extracted from RESQLY – Terms & Conditions PDF (RESQLY – Terms & Conditions.pdf).
export const TERMS_PDF_PAGES = [
  `RESQLY – Terms & Conditions

Effective Date: May 25, 2026
Company: Resqly Technologies Private Limited (“Resqly”, “we”, “our”, “us”)
Application Name: Resqly (“Platform”, “Application”, “App”)


---

1. INTRODUCTION

Welcome to Resqly.

These Terms & Conditions (“Terms”) govern your access to and use of the Resqly mobile
application, website, services, and all related technology platforms operated by Resqly
Technologies Private Limited.

By downloading, registering, accessing, or using Resqly, you agree to comply with and be
legally bound by these Terms.

If you do not agree with any part of these Terms, please do not use the Platform.


---

2. ABOUT RESQLY

Resqly is a technology platform that connects users with nearby service providers, emergency
support providers, and independent professionals for assistance and support services.

Resqly acts solely as a technology facilitator and intermediary platform.

Resqly does not directly provide medical treatment, ambulance services, healthcare advice,
emergency response operations, or professional consultation unless explicitly stated.

All services provided through the Platform are independently delivered by third-party providers
registered on the Platform.


---

3. ELIGIBILITY

To use Resqly:`,
  `You must be at least 18 years old.

You must have the legal capacity to enter into a binding agreement.

You must provide accurate and complete registration information.

You must comply with all applicable laws while using the Platform.


By using Resqly, you represent and warrant that you satisfy all eligibility requirements.


---

4. USER ACCOUNTS

4.1 Account Creation

Users may be required to create an account using:

Mobile number

Email address

OTP verification

Social login integrations


You agree to provide true, accurate, and updated information.

4.2 Account Responsibility

You are solely responsible for:

Maintaining confidentiality of your login credentials

All activities conducted under your account

Ensuring unauthorized access is prevented


Resqly shall not be responsible for any loss arising from unauthorized account usage.`,
  `4.3 Account Suspension

Resqly reserves the right to suspend, restrict, or terminate accounts that:

Violate these Terms

Engage in fraudulent activities

Abuse service providers or users

Use the Platform unlawfully

Share false or misleading information




---

5. NATURE OF SERVICES

Resqly provides:

Service discovery

Service provider matching

Emergency support coordination

Booking facilitation

Communication tools

Notifications and tracking features

Hyperlocal assistance services


The Platform may evolve and additional features may be introduced, modified, or removed at
any time.


---`,
  `6. IMPORTANT DISCLAIMER

6.1 No Medical Advice

Resqly does not provide:

Medical advice

Diagnosis

Prescription services

Clinical recommendations

Emergency healthcare treatment


Any information available on the Platform is for informational purposes only and should not be
considered medical advice.

Users should consult licensed medical professionals for medical concerns.

6.2 Emergency Situations

Resqly is not a substitute for official emergency services.

In life-threatening situations, users must immediately contact:

Local ambulance services

Hospitals

Police authorities

Fire departments

Government emergency helplines


Resqly does not guarantee:

Emergency response times

Availability of providers`,
  `Accuracy of location tracking

Immediate assistance




---

7. SERVICE PROVIDERS

7.1 Independent Providers

All service providers available on Resqly are independent third parties.

Resqly does not:

Employ providers

Control provider operations

Supervise medical practices

Guarantee qualifications beyond submitted verification documents


7.2 Verification

Resqly may perform verification checks including:

ID verification

License verification

Phone verification

Background checks where applicable


However, Resqly does not guarantee the accuracy, validity, or authenticity of provider
information.

7.3 User Responsibility`,
  `Users are responsible for independently evaluating providers before engaging services.


---

8. BOOKINGS & REQUESTS

Users may:

Request services

Schedule appointments

Contact providers

Accept quotations

Make payments


Resqly does not guarantee:

Acceptance of service requests

Availability of providers

Completion of services

Exact arrival times


Service providers may accept, reject, delay, or cancel requests based on their availability.


---

9. PAYMENTS

9.1 Payment Processing

Payments may be processed through third-party payment gateways.

By making payments through Resqly, you authorize us to facilitate payment collection on behalf
of providers.`,
  `9.2 Pricing

Pricing may vary depending on:

Distance

Service type

Demand

Availability

Time of day

Additional charges


Final pricing may differ from estimated pricing.

9.3 Refunds

Refund eligibility depends on:

Cancellation timing

Service completion status

Provider policies

Investigation outcomes


Resqly reserves the right to determine refund eligibility on a case-by-case basis.


---

10. CANCELLATIONS

Users may cancel bookings subject to cancellation policies displayed within the Platform.

Providers may also cancel bookings due to:`,
  `Unavailability

Safety concerns

Incorrect information

Operational limitations

Technical failures


Repeated misuse of cancellations may result in account restrictions.


---

11. USER CONDUCT

Users agree NOT to:

Abuse providers or users

Harass individuals

Upload illegal content

Share false information

Violate laws

Attempt hacking or reverse engineering

Interfere with Platform operations

Use the Platform fraudulently

Impersonate another person

Post offensive or harmful content


Resqly reserves the right to remove content and restrict accounts violating these Terms.`,
  `---

12. CONTENT & INTELLECTUAL PROPERTY

All Platform content including:

Logos

Branding

UI designs

Software

Graphics

Features

Text

Databases

Technology


are owned by or licensed to Resqly and protected under applicable intellectual property laws.

Users may not:

Copy

Reproduce

Sell

Distribute

Modify

Republish

Reverse engineer`,
  `any part of the Platform without written permission.


---

13. LOCATION SERVICES

Resqly may require access to:

GPS location

Background location

Device permissions

Notifications

Camera access

Microphone access


This information is used to:

Connect nearby providers

Improve response coordination

Enhance service quality

Enable safety features


Users may disable permissions, but some features may stop functioning.


---

14. PRIVACY

By using Resqly, you consent to the collection, storage, and usage of data as described in the
Privacy Policy.

This may include:`,
  `Personal information

Contact details

Device information

Usage analytics

Location information

Communication records


Resqly implements reasonable security measures but cannot guarantee absolute security.


---

15. THIRD-PARTY SERVICES

Resqly may integrate with third-party services including:

Payment gateways

Maps and navigation

SMS/OTP providers

Cloud hosting services

Analytics tools


Resqly is not responsible for the availability, functionality, or actions of third-party services.


---

16. NETWORK & TECHNICAL LIMITATIONS

Resqly does not guarantee uninterrupted availability of the Platform.

The Platform may experience:`,
  `Downtime

Server interruptions

GPS inaccuracies

Internet failures

Technical bugs

Delays in notifications


Users acknowledge that technology-based services may occasionally fail.


---

17. LIMITATION OF LIABILITY

To the maximum extent permitted under applicable law, Resqly shall not be liable for:

Indirect damages

Loss of profits

Personal injury

Medical outcomes

Service delays

Provider misconduct

Data loss

Unauthorized access

Technical interruptions

Emergency response failures`,
  `Users use the Platform at their own risk.


---

18. INDEMNIFICATION

You agree to indemnify and hold harmless Resqly, its founders, employees, affiliates, partners,
and agents against any claims, damages, liabilities, costs, or legal expenses arising from:

Your misuse of the Platform

Violation of these Terms

Violation of laws

Harm caused to providers or users

Unauthorized account activities




---

19. TERMINATION

Resqly reserves the right to suspend or terminate access without prior notice if:

Terms are violated

Fraudulent activity is detected

Platform misuse occurs

Legal obligations require action


Users may also discontinue use at any time.


---

20. MODIFICATIONS TO TERMS`,
  `Resqly may update these Terms periodically.

Updated Terms become effective upon publication on the Platform.

Continued usage after modifications constitutes acceptance of revised Terms.


---

21. GOVERNING LAW

These Terms shall be governed by the laws of India.

Any disputes arising from these Terms shall fall under the jurisdiction of courts located in
Bengaluru, Karnataka, India.


---

22. DISPUTE RESOLUTION

Any disputes arising out of these Terms shall first attempt to be resolved amicably.

If unresolved, disputes shall be subject to arbitration under the Arbitration and Conciliation Act,
1996.

The seat of arbitration shall be Bengaluru, Karnataka.


---

23. FORCE MAJEURE

Resqly shall not be held liable for delays or failures caused by events beyond reasonable
control including:

Natural disasters

Internet outages

Government restrictions

Pandemic situations`,
  `War

Strikes

Technical infrastructure failures




---

24. SEVERABILITY

If any provision of these Terms is found invalid or unenforceable, the remaining provisions shall
remain fully valid and enforceable.


---

25. CONTACT INFORMATION

For support, legal concerns, or grievances:

Resqly Support Team
Email: support@resqly.com
Website: www.resqly.com


---

26. ACKNOWLEDGEMENT

By using Resqly, you acknowledge that:

You have read these Terms

You understand these Terms

You agree to comply with these Terms

You use the Platform at your own discretion and risk




---`,
  `RESQLY PROVIDER TERMS

27. PROVIDER RESPONSIBILITIES

Providers using Resqly agree to:

Maintain valid licenses and permits where applicable

Provide accurate information

Deliver services professionally

Comply with applicable laws

Avoid fraudulent activities

Maintain respectful conduct toward users


Providers are solely responsible for the services they deliver.


---

28. PROVIDER VERIFICATION

Resqly may request:

Government ID

Professional licenses

Address proof

Bank details

Certifications

Vehicle information

Insurance details`,
  `Submission of documents does not guarantee approval.


---

29. PROVIDER PAYOUTS

Provider earnings may be subject to:

Platform fees

Taxes

Refund deductions

Penalties for fraud

Compliance verification


Payout schedules may vary.


---

30. PLATFORM RIGHTS

Resqly reserves the right to:

Remove providers

Suspend accounts

Investigate complaints

Modify service availability

Change commission structures

Reject onboarding applications


at its sole discretion.`,
  `---

31. FINAL AGREEMENT

These Terms constitute the complete agreement between users and Resqly regarding Platform
usage and supersede any previous agreements or understandings.

I’ve created a full custom Terms & Conditions document for your app Resqly tailored for an
India-based service/emergency assistance platform.`
];
